import script from "./CreateCompanyAdminDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateCompanyAdminDrawer.vue?vue&type=script&setup=true&lang=js"

import "./CreateCompanyAdminDrawer.vue?vue&type=style&index=0&id=b5505f3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5505f3c"]])

export default __exports__